/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_Type_DefaultInputs */

const en_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const fr_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par défaut`)
};

const de_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const it_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinito`)
};

const ru_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По умолчанию`)
};

const es_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por defecto`)
};

const zh_cn2_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认`)
};

const ja_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルト`)
};

const hi_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती करना`)
};

const pt_pt2_options_general_project_type_default = /** @type {(inputs: Options_General_Project_Type_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrão`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Options_General_Project_Type_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_type_default = /** @type {((inputs?: Options_General_Project_Type_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_Type_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_project_type_default(inputs)
	if (locale === "de") return de_options_general_project_type_default(inputs)
	if (locale === "it") return it_options_general_project_type_default(inputs)
	if (locale === "ru") return ru_options_general_project_type_default(inputs)
	if (locale === "es") return es_options_general_project_type_default(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_project_type_default(inputs)
	if (locale === "ja") return ja_options_general_project_type_default(inputs)
	if (locale === "hi") return hi_options_general_project_type_default(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_project_type_default(inputs)
	return en_options_general_project_type_default(inputs)
});